export default "__VITE_ASSET__BZ363DJT__"